import { useState } from "react";
import { apiGetBlob } from "../../lib/api";
import { Card } from "../ui/Card";
import { Button } from "../ui/Button";
import { SectionHeader } from "../ui/SectionHeader";

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default function ReportPanel({ address, accessToken }: { address: string; accessToken: string | null }) {
  const [error, setError] = useState<string | null>(null);
  const [loadingFormat, setLoadingFormat] = useState<string | null>(null);

  async function downloadJson() {
    setError(null);
    setLoadingFormat("json");
    try {
      const blob = await apiGetBlob(`/api/trace/report/${address}/json`);
      downloadBlob(blob, `investigation-${address.slice(0, 10)}.json`);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoadingFormat(null);
    }
  }

  async function downloadGated(format: "csv" | "pdf") {
    setError(null);
    if (!accessToken) {
      setError("Unlock the full investigation below first.");
      return;
    }
    setLoadingFormat(format);
    try {
      const blob = await apiGetBlob(`/api/trace/report/${address}/${format}`, {
        Authorization: `Bearer ${accessToken}`,
      });
      downloadBlob(blob, `investigation-${address.slice(0, 10)}.${format}`);
    } catch (e) {
      setError(
        e instanceof Error && (e.message.includes("requires the plan") || e.message.includes("access token"))
          ? "This requires the paid report unlock — see the panel below."
          : e instanceof Error
          ? e.message
          : String(e)
      );
    } finally {
      setLoadingFormat(null);
    }
  }

  return (
    <Card padding="md">
      <SectionHeader title="Investigation report" />
      <div className="flex flex-col gap-2">
        <Button variant="ghost" size="sm" onClick={downloadJson} disabled={loadingFormat === "json"} className="justify-start">
          {loadingFormat === "json" ? "Preparing…" : "Free summary (JSON)"}
        </Button>
        <Button variant="ghost" size="sm" onClick={() => downloadGated("csv")} disabled={loadingFormat === "csv"} className="justify-start">
          {loadingFormat === "csv" ? "Preparing…" : "Full report (CSV) — paid"}
        </Button>
        <Button variant="ghost" size="sm" onClick={() => downloadGated("pdf")} disabled={loadingFormat === "pdf"} className="justify-start">
          {loadingFormat === "pdf" ? "Preparing…" : "Full report (PDF) — paid"}
        </Button>
      </div>
      {error && <p className="mt-2 text-xs text-red-400">{error}</p>}
    </Card>
  );
}
